import React from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import { Link } from "react-router-dom";
import { Button, Col, Container, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import './BlogStyle.css'
// import blog1 from
import blogs from '../assets/data/blogCardsInfo';


const BlogItem = ({ blog }) => {
	return (
		<article className="ezy__blog2-post rounded overflow-hidden h-100">
			<img src={blog.image} alt="" className="img-fluid w-100" />
			<div className="p-3 p-md-4" dir="rtl" style={{ textAlign: 'justify' }} >
				<h4 className="ezy__blog2-title fs-4 mb-2">{blog.title}</h4>
				<p className="ezy__blog2-author" >
					{/* <span className="me-2">نوشته شده بوسیله 
					{blog.author} 
					</span> */}
					
					<span >
					&nbsp;&nbsp;  <span>{blog.date}</span>
					</span>
				</p>
				<p className="ezy__blog2-description mt-3 mb-4" style={{ whiteSpace: 'pre-wrap'}}>{blog.description}</p>
				
			
				<Link to={`/blog/${blog.id}`} style={{ textDecoration: 'none' }}>
					<Button 
					variant=""
					className="ezy__blog2-btn-read-more" 
					>
					میخونم
					</Button>
				</Link>

			</div>
		</article>
	);
};

BlogItem.propTypes = {
	blog: PropTypes.object.isRequired,
};

const Blog = () => {
	useEffect(() => {
		AOS.init({ duration: 1000, once: true }); // Animations trigger once with a 1-second duration
	  }, []);
	return (
		<section className="ezy__blog2 light" id="blog2">
			<Container>
				<Row className="justify-content-center">
					<Col lg={8} className="text-center">
						<h2 className="ezy__blog2-heading mb-3 mt-0">
						تور مقاله‌نویسی 
						</h2>
						<p className="ezy__blog2-sub-heading px-lg-5 mb-4">
						انجام تحقیق علمی معتبر مسیری پرچالش است
						<br />
						شما در این مسیر نیاز به آموزش دارید
						<br />
						بلاگ‌های زیر رو بخونید
						</p>
					</Col>
				</Row>
				<Row className="mt-3 mt-md-5">
					{blogs.map((blog, i) => (
						<Col 
						xs={12}
						md={6}
						lg={4} 
						className="mt-4" 
						key={i} 
						data-aos="flip-up"
						data-aos-duration="500"
						data-aos-delay={`${i * 75}`} 
						>
							<BlogItem blog={blog} />
						</Col>
					))}
				</Row>
			</Container>
			<Row 
			style={{display: "flex",
				alignItems: "center",
				justifyContent: "center",
				height: "20vh", 
				textAlign: "center",}}
			data-aos="fade-up"
			data-aos-duration="1000"
			data-aos-delay={`${100}`} >
			<Link to="/posts">
			<br />
				<Button variant="" className="ezy__blog2-btn">
						پست‌های بیشتر
				</Button>
			</Link>
			</Row>
		</section>
	);
};


export default Blog;